interface TriggerRecipeImageGenerationOptions {
  requestErrorLabel?: string;
  responseErrorLabel?: string;
}

const DEFAULT_OPTIONS: Required<TriggerRecipeImageGenerationOptions> = {
  requestErrorLabel: "Erreur lors du trigger de génération d'image :",
  responseErrorLabel: "Erreur de la fonction Netlify de génération d'image:",
};

export const triggerRecipeImageGeneration = async (
  recipeId: string,
  token: string,
  options: TriggerRecipeImageGenerationOptions = {}
) => {
  const { requestErrorLabel, responseErrorLabel } = {
    ...DEFAULT_OPTIONS,
    ...options,
  };

  return fetch('/.netlify/functions/generate-single-recipe-image', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-client-token': token,
    },
    body: JSON.stringify({ recipeId }),
  })
    .then(async (response) => {
      if (!response.ok) {
        const errorPayload = await response.json();
        console.error(
          responseErrorLabel,
          response.status,
          response.statusText,
          errorPayload
        );
      }
    })
    .catch((error) => {
      console.error(requestErrorLabel, error);
    });
};
